import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import HomePageWrapper from '../pages/home/HomePageWrapper'
import NewEditProject from '../pages/project/NewEditProject'
import NPConstruction from '../pages/project/NewEditProjectTabs/NPConstruction'
import NPTheProject from '../pages/project/NewEditProjectTabs/NPTheProject'
import NPUseCondition from '../pages/project/NewEditProjectTabs/NPUseCondition'
import NPPrestation from '../pages/project/NewEditProjectTabs/NPPrestation'
import NPProposal from '../pages/project/NewEditProjectTabs/NPProposal'

const   PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  //const NPConstruction = lazy (() => import ('../pages/project/NewEditProjectTabs/NPConstruction'))
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='login/*' element={<Navigate to='/home' />} />
        <Route path='auth/*' element={<Navigate to='/home' />} />
        <Route path='home' element={<HomePageWrapper />} />
        <Route path='new-project' element={<NewEditProject />}>
          <Route path='tab1' element={
              <NPConstruction />
          } />
          <Route path='tab2' element={<NPTheProject />} />
          <Route path='tab3' element={<NPUseCondition />} />
          <Route path='tab4' element={<NPPrestation />} />
          <Route path='tab5' element={<NPProposal />} />
          <Route path='tab1/:pGuid' element={<NPConstruction />} />
          <Route path='tab2/:pGuid' element={<NPTheProject />} />
          <Route path='tab3/:pGuid' element={<NPUseCondition />} />
          <Route path='tab4/:pGuid' element={<NPPrestation />} />
          <Route path='tab5/:pGuid' element={<NPProposal />} />
        </Route>
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
